import { GuestUsersAuthApi } from '@agilelab/plugin-wb-guest-users-auth-common';
import { ApiRef, createApiRef } from '@mainstage/core-plugin-api';

export const guestUsersApiRef: ApiRef<GuestUsersAuthApi> = createApiRef({
  id: 'plugin.guest-users.service',
});
